export const eventDateTimeFormat = 'MMM D HH:mm';
export const eventHourFormat = 'HH:mm';
export const dateFormat = 'D MMM YYYY';
export const chatMessageDateTimeFormat = `${dateFormat}, h:mm a`;
export const birthDayFormat = 'MM/DD/YYYY';